import React, { useEffect, useState } from "react"
import { Schedule } from "source/giving/donate/form/types"
import { fetchStartDates } from "../queries"
import { useQuery } from "@tanstack/react-query"
import { dateStampStringToLocal } from "source/giving/donate/form/utils/frequency"

interface NextOccurrenceProps {
  schedule: Schedule
  releaseHoldAt: string | null
  nextOccurrence: string | null
  onChangeNextOccurrence: (nextOccurrence: string | null) => void
}

export default function NextOccurrence({
  schedule,
  releaseHoldAt,
  nextOccurrence,
  onChangeNextOccurrence,
}: NextOccurrenceProps) {
  const [internalNextOccurrence, setInternalNextOccurrence] = useState<
    string | null
  >(nextOccurrence)

  useEffect(() => {
    setInternalNextOccurrence("")
  }, [schedule, releaseHoldAt])

  const {
    data: nextOccurrences,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["RecurringDonationStartDates", schedule, releaseHoldAt],
    queryFn: () => fetchStartDates(schedule, releaseHoldAt),
    enabled: nextOccurrence !== internalNextOccurrence,
  })

  useEffect(() => {
    const firstOccurrence = nextOccurrences?.[0] ?? null

    if (firstOccurrence && firstOccurrence !== internalNextOccurrence) {
      setInternalNextOccurrence(firstOccurrence)
      onChangeNextOccurrence(firstOccurrence)
    }
  }, [nextOccurrences, internalNextOccurrence, onChangeNextOccurrence])

  return (
    !isError &&
    internalNextOccurrence && (
      <span>
        {isFetching
          ? "..."
          : `${dateStampStringToLocal(internalNextOccurrence)}.`}
      </span>
    )
  )
}
